/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * @author Eugene Semennikov esemennikov@openprovider.ru
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name prices
 * @description
 *
 * # prices
 *
 * The `prices` module provides prices managment - list/search/filter/change.
 */
angular.module("prices")
  .constant("priceListDefaultPageSize", 5)
  .constant("priceListPageSizes", [10, 25, 50, 100])
  .constant("priceListControlSize", 10)
/**
 * @ngdoc controller
 * @name priceListCtrl
 * @requires $scope, $filter, $modal, $location, $aside, b17Service, userCache, auth, exportService
 *
 * @description
 * Price list Controller
 */
  .controller("priceListCtrl", function (
    $scope, $filter, $modal, $location, $aside, b17Service, userCache, auth, exportService,
    priceListDefaultPageSize, priceListPageSizes, priceListControlSize, exportToCsv) {

    // init error message
    $scope.errorMessage = null;

    $scope.location = $location.path();
    
    $scope.clientName = null;
    $scope.clientTier = null;
    $scope.client = auth.getClient();
    
    $scope.data = {
      prices: [],
      versions: [],
      clients: [],
    };

    // init price version
    $scope.selectedVersion = userCache.get('priceListSelectedVersion');
    // init grops
    var selectedGroup = userCache.get('priceListSelectedGroup');
    // init operations
    var selectedOperation = userCache.get('priceListSelectedOperation');

    // init product name filter
    $scope.selectedProduct = userCache.get('priceListSelectedProduct');
    // init article name filter
    $scope.selectedArticle = userCache.get('priceListSelectedArticle');
    // init provider name filter
    $scope.selectedProvider = userCache.get('priceListSelectedProvider');

    // init legacy providers filter
    $scope.legacy = userCache.get('priceListLegacy');
    $scope.legacy = $scope.legacy || 'false';

    // -------------
    // GET REST DATA
    // -------------

    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        $scope.data.config = config.data.data.results[0];
        if (angular.isUndefined($scope.selectedVersion)) {
          $scope.selectedVersion = $scope.data.config.version;
        }
      } else {
        checkErrorCodeMessage();
      }
    });

    b17Service.getGroups().then(function (groups) {
      if (groups.data && groups.data.data) {
        $scope.data.groups = groups.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    loadClient();
    
    // get editions data (price versions without promotions)
    b17Service.getEditions().then(function (editions) {
      if (editions.data && editions.data.data) {
        $scope.data.versions = _.sortBy(editions.data.data.results, 'number');
        loadPrices();
      } else {
        checkErrorCodeMessage();
      }
    });

    // ----------
    // PAGINATION
    // ----------

    // init pagination
    $scope.defaultPageSize = priceListDefaultPageSize;
    $scope.pageSize = userCache.get('priceListPageSize') || priceListDefaultPageSize;
    $scope.pageSizes = priceListPageSizes;
    $scope.controlMaxSize = priceListControlSize;
    $scope.currentPage = userCache.get('priceListCurrentPage') || 1;

    $scope.pageChanged = function() {
      userCache.put('priceListCurrentPage', $scope.currentPage);
    };
    
    // ---------
    // SELECTORS
    // ---------

    // select page size
    $scope.selectPageSize = function (count) {
      $scope.pageSize = count;
      userCache.put('priceListPageSize', count);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select price version
    $scope.selectVersion = function (version) {
      $scope.selectedVersion = version;
      userCache.put('priceListSelectedVersion', version);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select group
    $scope.selectGroup = function (group) {
      selectedGroup = group;
      userCache.put('priceListSelectedGroup', group);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select operation
    $scope.selectOperation = function (operation) {
      selectedOperation = operation;
      userCache.put('priceListSelectedOperation', operation);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select product name
    $scope.selectProduct = function (product) {
      $scope.selectedProduct = product;
      userCache.put('priceListSelectedProduct', product);
    };

    // select article name
    $scope.selectArticle = function (article) {
      $scope.selectedArticle = article;
      userCache.put('priceListSelectedArticle', article);
    };

    // select provider name
    $scope.selectProvider = function (provider) {
      $scope.selectedProvider = provider;
      userCache.put('priceListSelectedProvider', provider);
    };

    // -------
    // FILTERS
    // -------

    $scope.versionFilter = function (item) {
      return angular.isUndefined(selectedVersion) ||
        selectedVersion === null ||
        item.version === selectedVersion;
    };

    $scope.groupFilter = function (item) {
      return angular.isUndefined(selectedGroup) || 
        selectedGroup === null ||
        item.group === selectedGroup;
    };

    $scope.operationFilter = function (item) {
      return angular.isUndefined(selectedOperation) ||
        selectedOperation === null ||
        item.operation === selectedOperation;
    };

    $scope.productFilter = function (item) {
      return angular.isUndefined($scope.selectedProduct) || 
        $scope.selectedProduct === null ||
        $scope.selectedProduct === '' ||
        item.product === $scope.selectedProduct;
    };

    $scope.articleFilter = function (item) {
      return angular.isUndefined($scope.selectedArticle) || 
        $scope.selectedArticle === null ||
        $scope.selectedArticle === '' ||
        item.article === $scope.selectedArticle;
    };

    $scope.providerFilter = function (item) {
      return angular.isUndefined($scope.selectedProvider) || 
        $scope.selectedProvider === null ||
        $scope.selectedProvider === '' ||
        item.provider === $scope.selectedProvider;
    };

    $scope.filterLegacy = function () {
      if ($scope.legacy === 'false') {
        $scope.legacy = 'true';
      } else {
        $scope.legacy = 'false';
      }
      userCache.put('priceListLegacy', $scope.legacy);
      loadPrices();
    };

    // --------
    // WATCHERS
    // --------

    $scope.$watch('selectedProduct', function(newValue) {
      userCache.put('priceListSelectedProduct', newValue);
    });

    $scope.$watch('selectedArticle', function(newValue) {
      userCache.put('priceListSelectedArticle', newValue);
    });

    $scope.$watch('selectedProvider', function(newValue) {
      userCache.put('priceListSelectedProvider', newValue);
    });

    $scope.$watch( function(){ return auth.getClient(); },
      _.debounce(function() {
        loadPrices(true);
        loadClient(true);
      }, 1000)
    );

    // -------
    // GETTERS
    // -------

    // get version description
    $scope.getVersionDescription = function () {
      var versionDescription = "All versions";
      if ($scope.selectedVersion) {
        $scope.data.versions.forEach(function (version) {
          if (version.number === $scope.selectedVersion) {
            versionDescription = version.description;
          }
        });
      }
      return versionDescription;
    };

    // get group
    $scope.getGroup = function () {
      return selectedGroup || 'All products';
    };

    // get operation
    $scope.getOperation = function () {
      return selectedOperation || 'All operations';
    };

    // -------------------
    // BREADCRUMB & RESETS
    // -------------------

    $scope.checkBreadcrumb = function(name) {
      var version = ($scope.data.config && $scope.data.config.version) ? $scope.data.config.version : 1;

      switch (name) {
        case 'prices':
          return $scope.selectedVersion !== version || selectedGroup || selectedOperation ||
            $scope.selectedProduct || $scope.selectedArticle || $scope.selectedProvider;
        case 'versions':
          return selectedGroup || selectedOperation || $scope.selectedProduct ||
            $scope.selectedArticle || $scope.selectedProvider;
        case 'groups':
          return selectedOperation || $scope.selectedProduct ||
            $scope.selectedArticle || $scope.selectedProvider;
        case 'operations':
          return $scope.selectedProduct || $scope.selectedArticle || $scope.selectedProvider;
        case 'products':
          return $scope.selectedArticle || $scope.selectedProvider;
        case 'articles':
          return $scope.selectedProvider;
      }
      return false;
    };

    $scope.resetAll = function () {
      $scope.selectProvider(null);
      $scope.selectArticle(null);
      $scope.selectProduct(null);
      $scope.selectOperation(null);
      $scope.selectGroup(null);
      $scope.selectVersion($scope.data.config.version);
    };

    $scope.resetFilters = function(name) {
      switch (name) {
        case 'prices':
          $scope.resetAll();
          return;
        case 'versions':
          $scope.selectGroup(null);
          $scope.selectProvider(null);
          $scope.selectArticle(null);
          $scope.selectProduct(null);
          $scope.selectOperation(null);
         break;
        case 'groups':
          $scope.selectProvider(null);
          $scope.selectArticle(null);
          $scope.selectProduct(null);
          $scope.selectOperation(null);
         break;
        case 'operations':
          $scope.selectProvider(null);
          $scope.selectArticle(null);
          $scope.selectProduct(null);
          break;
        case 'products':
          $scope.selectProvider(null);
          $scope.selectArticle(null);
          break;
        case 'articles':
          $scope.selectProvider(null);
      }
    };

    // -------------------
    // CHECKUPS
    // -------------------

    // check if regular price has difference
    $scope.regularPrice = [];
    $scope.checkRegularPrice = function (item) {
      if (item.promotion) {
        b17Service.getPrice(
          {
            version: $scope.selectedVersion,
            group: item.group,
            product: item.product,
            provider: item.provider,
            article: item.article,
            operation: item.operation,
            quantity: item.quantity,
          }).then(function (prices) {
            if (prices.data && prices.data.data) {
              $scope.regularPrice[item.id] = prices.data.data.results[0].tier;
              $scope.regularPrice[item.id].cost = prices.data.data.results[0].cost;
              $scope.regularPrice[item.id].extras = prices.data.data.results[0].extras;
            } else {
              checkErrorCodeMessage();
            }
          }
        );
      }
    };
    
    $scope.exportFiltered = function () {
      var exportFilter = {};
      if (selectedGroup) {
        exportFilter.group = selectedGroup;
      }
      if ($scope.selectedProduct) {
        exportFilter.product = $scope.selectedProduct;
      }
      if ($scope.selectedProvider) {
        exportFilter.provider = $scope.selectedProvider;
      }
      if ($scope.selectedArticle) {
        exportFilter.article = $scope.selectedArticle;
      }
      if (selectedOperation) {
        exportFilter.operation = selectedOperation;
      }
      var filteredPrices = _.filter($scope.data.prices[$scope.selectedVersion], exportFilter);
      var csvPrices = 'Version, Promo, Group, Product, Provider, Article, Operation, Quantity, Currency';
      if ($scope.client && $scope.client !== 1 &&  $scope.data.clients.length === 1 && $scope.data.clients[0].relations.tier) {
        csvPrices += ', Prime'; 
      } else {
        csvPrices += ', Cost, Extras';
      }
      $scope.data.config.tiers.forEach(function(item) {
        if ($scope.client && $scope.client !== 1 && $scope.data.clients.length === 1 && $scope.data.clients[0].relations.tier) {
          if ($scope.data.clients[0].relations.tier === item) {
            csvPrices += ', Tier.' + item; 
          }
        } else {
          csvPrices += ', Tier.' + item; 
        }
      });
      filteredPrices.forEach(function(item) {
        csvPrices += '\r\n' + $scope.selectedVersion;
        if (angular.isDefined(item.promotion) && item.promotion > 0) {
          csvPrices += ', ' + item.promotion;
        } else {
          csvPrices += ', none';
        }
        csvPrices += ', ' + item.group + ', ' + item.product + ', ' + item.provider +
          ', ' + item.article + ', ' + item.operation + ', ' + item.quantity + ', ' + item.currency;
          if ($scope.client && $scope.client !== 1 && $scope.data.clients.length === 1 && $scope.data.clients[0].relations.tier) {
            csvPrices += ', ' + parseFloat((item.cost + item.extras).toFixed(2)); 
          } else {
            csvPrices += ', ' + item.cost + ', ' + item.extras;
          }
        $scope.data.config.tiers.forEach(function(name) {
          if ($scope.client && $scope.client !== 1 &&  $scope.data.clients.length === 1 && $scope.data.clients[0].relations.tier) {
            if ($scope.data.clients[0].relations.tier === name) {
              csvPrices += ', ' + item.tier[name]; 
            }
          } else {
            csvPrices += ', ' + item.tier[name]; 
          }
        });
      });
      exportService.saveBlob(new Blob([csvPrices], {type: "text/csv"}), 'filtered_prices.csv');
    };
    
    // ----------------------
    // ADD/CHANGE PRICE LINES
    // ----------------------

    // create price line
    $scope.createPriceLine = function (version) {

      auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          var priceLineWindow = $modal.open({
            templateUrl: 'prices/new-price-line.html',
            controller: 'createPriceLineCtrl',
            size: 'xlg',
            backdrop: 'static',
            resolve: {
              priceLineVersion: function () {
                return version;
              }
            }
          });
          priceLineWindow.result.then(function (message) {
            // renew prices
            b17Service.getResponse().then(function (response) {
              $scope.data.versions.forEach(function (item) {
                b17Service.getPrices({
                  cache: false,
                  version: item.number,
                  legacy: $scope.legacy,
                  token: auth.getClient(),
                }).then(function (prices) {
                  if (prices.data && prices.data.data) {
                    $scope.data.prices[item.number] = prices.data.data.results;
                  } else {
                    checkErrorCodeMessage();
                  }
                });
              });
            });
            console.log(message);
          }, function () {
            console.log('Modal dismissed at: ' + new Date());
          });
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
         }
      });
    };

    $scope.openPromotion = function (item) {
      if (item.promotion) {
        b17Service.getPromotions(
          {
            id: item.promotion,
          }).then(function (response) {
            if (_.has(response, 'data.data.results[0].name')) {
              userCache.put('promotionListSelectedName', response.data.data.results[0].name);
              $location.path('/promotions');
            } else {
              checkErrorCodeMessage();
            }
          }
        );
      }
    };


    // open price line window
    $scope.openPriceLine = function (item) {

      auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          var priceLineWindow = $modal.open({
            templateUrl: 'prices/price-line.html',
            controller: 'priceLineCtrl',
            size: 'xlg',
            backdrop: 'static',
            resolve: {
              priceLine: function () {
                item.version = $scope.selectedVersion;
                return item;
              }
            }
          });
          priceLineWindow.result.then(function (message) {
            // renew prices
            b17Service.getResponse().then(function (response) {
              $scope.data.versions.forEach(function (item) {
                b17Service.getPrices({
                  cache: false,
                  version: item.number,
                  legacy: $scope.legacy,
                  token: auth.getClient(),
                }).then(function (prices) {
                  if (prices.data && prices.data.data) {
                    $scope.data.prices[item.number] = prices.data.data.results;
                  } else {
                    checkErrorCodeMessage();
                  }
                });
              });
            });
            console.log(message);
          }, function () {
            console.log('Modal dismissed at: ' + new Date());
          });
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
         }
      });
    };

    // ---------------
    // ERRORS HANDLING
    // ---------------

    // clear error message
    $scope.dismissError = function() {
      $scope.errorMessage = null;
    };

    // -----------------
    // SERVICE FUNCTIONS
    // -----------------

    function loadPrices(ignoreErrors) {
      $scope.data.versions.forEach(function (item) {
        b17Service.getPrices({
          version: item.number,
          legacy: $scope.legacy,
          token: auth.getClient(),
        }).then(function (prices) {
          if (prices.data && prices.data.data) {
            $scope.data.prices[item.number] = prices.data.data.results;
          } else {
            if (!ignoreErrors) {
              checkErrorCodeMessage();
            }
          }
        });
      });
    }
    
    function loadClient(ignoreErrors) {
      b17Service.getClients({ 
        id: auth.getClient(),
      }).then(function (clients) {
        if (clients.data && clients.data.data.success) {
          $scope.data.clients = clients.data.data.results;
          if ($scope.data.clients.length == 1) {
            $scope.client = $scope.data.clients[0].id;
            $scope.clientName = $scope.data.clients[0].company;
            if ($scope.data.clients[0].relations.tier) {
              $scope.clientTier = $scope.data.clients[0].relations.tier;
            }
          }
        } else {
          if (!ignoreErrors) {
            checkErrorCodeMessage();
          }
        }
      });
    }

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        $scope.errorMessage = 'Error: (' + userCache.get('lastErrorCode') + ') ' + userCache.get('lastErrorMessage');
      } else {
        $scope.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

    // ----------------------------------
    // EXPORT TO CSV, created by Eugene Semennikov
    // ----------------------------------

    $scope.exportAllProductRecordsToCsv = function (group) {
      var versionNumber = 1; // general price version
      exportToCsv.downloadAllProductRecordsToFile(group, $scope.data.prices[versionNumber]);
    };

  });

})();
